module.exports = __webpack_public_path__ + "img/no-data.3f22132a.png";